import { render, staticRenderFns } from "./TopTravels.vue?vue&type=template&id=4e4db7c1&"
import script from "./TopTravels.vue?vue&type=script&lang=js&"
export * from "./TopTravels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports